import type { ComponentProps } from 'react';
import { Modal } from 'is24-corecss';
import { styles } from './styles';
import { useSlots } from './SlotContext';

export const Content = ({ className = '', ...props }: ComponentProps<typeof Modal.Body>) => {
  const { compact } = useSlots();
  return (
    <Modal.Body
      {...props}
      className={`padding-none ${styles.body} ${compact ? styles.compactBody : ''} ${className}`}
    />
  );
};
